import * as React from 'react';
import { ColorPicker as ColorHexPicker } from '@fluentui/react/lib/ColorPicker';
import { DefaultButton } from '@fluentui/react/lib/Button';
import { confirmButtonLabel } from './ColorPicker.locstring.json';
import loc from 'owa-localize';
import type { IColor } from '@fluentui/react/lib/Color';
import { observer } from 'mobx-react-lite';
import { DEFAULT_OUTLOOK_THEME_COLOR } from 'owa-theme';
import { useThrottle } from 'owa-react-hooks/lib/useThrottle';

import styles from './HexColorPickerWithPreview.scss';

const DEFAULT_HEX_COLOR = DEFAULT_OUTLOOK_THEME_COLOR;
const THROTTLE_DELAY = 100;

export interface HexColorPickerWithPreviewProps {
    color?: string;
    onColorSelected: (color: string) => void;
    Preview?: React.ComponentType<{ color: string }>;
}

export const HexColorPickerWithPreview = observer(function HexColorPickerWithPreview(
    props: HexColorPickerWithPreviewProps
) {
    const { color, onColorSelected, Preview } = props;
    const initialColor = color || DEFAULT_HEX_COLOR;
    const [internalColor, setInternalColor] = React.useState<string>(initialColor);

    const throttledUpdateColor = useThrottle(setInternalColor, THROTTLE_DELAY);

    const onHexColorChanged = React.useCallback(
        (ev: React.SyntheticEvent<HTMLElement>, color: IColor) => {
            throttledUpdateColor(color.str);
        },
        [throttledUpdateColor]
    );

    const onConfirm = React.useCallback(() => {
        onColorSelected(internalColor);
    }, [internalColor]);

    return (
        <div>
            <ColorHexPicker
                color={internalColor}
                onChange={onHexColorChanged}
                alphaSliderHidden={true}
            />
            {Preview && <Preview color={internalColor} />}
            <DefaultButton className={styles.confirmButton} onClick={onConfirm}>
                <span>{loc(confirmButtonLabel)}</span>
            </DefaultButton>
        </div>
    );
});
